
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";

import PageHeading from "@/components/PageHeading.vue";
import { ViewAnalytics } from "@/mixins";
import { RouterService } from "@/services";
import { MetadataKeys, VignetteRoutes } from "@/types";

@Component({
  components: {
    PageHeading,
  },
})
export default class FAQ extends mixins(ViewAnalytics) {
  // Override for PageTitle mixin
  pageName = "FAQ";

  private panelModel = [];

  mounted(): void {
    this.setAnalyticsMetadata(MetadataKeys.PAYWALLED_CONTENT_STATUS, "Public");
    this.setAnalyticsMetadata(MetadataKeys.PAGE_TYPE, "Public Page");
    this.setAnalyticsMetadata(MetadataKeys.SITESECTION, "Public Pages");
    this.pushPageViewEvent();
  }

  goToContactPage(): void {
    RouterService.navigateByName(this.$router, VignetteRoutes.Contact);
  }
}
